import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import { AuthProvider, SUPERADMIN } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import JourneyTracker from "./components/JourneyTracker";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import QRListPage from "./pages/QRListPage";
import QRDetailPage from "./pages/QRDetailPage";
import UsersPage from "./pages/UsersPage";

function App() {
  return (
    <AuthProvider>
      <Router>
        <JourneyTracker />
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route path="/qrs" element={<QRListPage />} />
            <Route path="/qrs/:id" element={<QRDetailPage />} />
            <Route
              path="/users"
              element={
                <ProtectedRoute allowedRoles={[SUPERADMIN]}>
                  <UsersPage />
                </ProtectedRoute>
              }
            />
          </Route>

          <Route path="*" element={<Navigate to="/qrs" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
